module.exports = __webpack_public_path__ + "img/Frame 1103hrp4.22150e04.png";